// lib/apiConfig.js
// =============================================================================
// SINGLE SOURCE for the Sales Engine origin and the WTR service token.
// The token literal was removed from source (it appeared in seven files and in
// git history; treat the old value as public). The value now comes from the
// Vercel build environment: REACT_APP_WTR_TOKEN.
//
// HONESTY NOTE (do not delete): a CRA env var is inlined at build time and
// still ships in the public bundle. This module does NOT make the token
// secret. It makes it single-sourced and rotatable without code edits.
// Real per-user security is the X-WTR-Auth session (requireUser server-side).
// The session-only end state lands with the OAuth2/native auth phase.
// =============================================================================

export const API_BASE = "https://generosity-sales-engine-mvp-api.onrender.com";

export const SERVICE_TOKEN = process.env.REACT_APP_WTR_TOKEN || "";

if (!SERVICE_TOKEN) {
  // Build misconfiguration: set REACT_APP_WTR_TOKEN in Vercel BEFORE building.
  // eslint-disable-next-line no-console
  console.error("[apiConfig] REACT_APP_WTR_TOKEN is not set; API calls will 401.");
}
